import { render, staticRenderFns } from "./StockOut.vue?vue&type=template&id=b64a70ce"
import script from "./StockOut.vue?vue&type=script&lang=js"
export * from "./StockOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports